"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const react_1 = __importStar(require("react"));
const clone_valid_element_1 = require("../../utils/clone-valid-element");
const MenuItem = ({ currentLocation, isSelected = false, setIsSelected, index, children, section, }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(isSelected || (section && (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.includes(section))));
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, (child) => {
        return (0, clone_valid_element_1.cloneValidElement)(child, {
            isOpen,
            setIsOpen,
            index,
            setIsSelected,
            currentLocation,
            section,
        });
    })));
};
exports.MenuItem = MenuItem;
exports.MenuItem.displayName = 'MenuItem';
exports.default = exports.MenuItem;
//# sourceMappingURL=menu-item.js.map